import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-check-by-funkprotokoll-fall';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentCheckByFunkprotokollFallEffects {

    IncidentCheckByFunkprotokollFall$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL),
        mergeMap((x: ac.GetIncidentCheckByFunkprotokollFallAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentCheckByFunkprotokollFall(x.fall_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentCheckByFunkprotokollFallErfolgreichAction(result, x.fall_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentCheckByFunkprotokollFallFehlerAction(error, x.fall_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
